import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';

import { GatewayCommissioningStore, GATEWAY_COMMISSIONING_STEP } from '@store';
import { TranslateService } from '@ngx-translate/core';

export enum ENTRY_POINTS {
  Big_Screen_Control_Unit = '7" Control unit',
  Small_Screen_Control_Unit = '3,5" Control unit',
  Rectangle_Control_Unit = 'Rectangle control unit',
  Square_Control_Unit = 'Square Control Unit',
  Vitoair = 'Vitoair',
  Vitovent = 'Vitovent',
  Viessmann_Invisible = 'Viessmann Invisible',
  Vitopure = 'Vitopure',
  Vitoset_Aqua = 'Vitoset Aqua',
}

@Component({
  selector: 'app-one-base-instructions',
  templateUrl: './one-base-instructions.component.html',
  styleUrls: ['./one-base-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneBaseInstructionsComponent implements OnInit {
  @Output() nextStep = new EventEmitter();
  @Output() previousStep = new EventEmitter();
  selectedEntryPoint: { name: ENTRY_POINTS; instructions: string[]; translatedName: string };
  availableEntryPoints: {
    name: ENTRY_POINTS;
    instructions: string[];
    translatedName: string;
  }[];

  constructor(
    public gatewayCommissioningStore: GatewayCommissioningStore,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.availableEntryPoints = [
      {
        name: ENTRY_POINTS.Big_Screen_Control_Unit,
        translatedName: this.translate.instant(
          '+GATEWAY_COMMISSIONING_REDESIGN.BIG_SCREEN_CONTROL_UNIT_NAME'
        ),
        instructions: [
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_BIG_SCREEN_CONTROL_UNIT_1'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_BIG_SCREEN_CONTROL_UNIT_2'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_BIG_SCREEN_CONTROL_UNIT_3'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_BIG_SCREEN_CONTROL_UNIT_4'
          ),
        ],
      },
      {
        name: ENTRY_POINTS.Small_Screen_Control_Unit,
        translatedName: this.translate.instant(
          '+GATEWAY_COMMISSIONING_REDESIGN.SMALL_SCREEN_CONTROL_UNIT_NAME'
        ),
        instructions: [
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SMALL_SCREEN_CONTROL_UNIT_1'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SMALL_SCREEN_CONTROL_UNIT_2'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SMALL_SCREEN_CONTROL_UNIT_3'
          ),
        ],
      },
      {
        name: ENTRY_POINTS.Rectangle_Control_Unit,
        translatedName: this.translate.instant(
          '+GATEWAY_COMMISSIONING_REDESIGN.RECTANGLE_CONTROL_UNIT_NAME'
        ),
        instructions: [
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_RECTANGLE_CONTROL_UNIT_1'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_RECTANGLE_CONTROL_UNIT_2'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_RECTANGLE_CONTROL_UNIT_3'
          ),
        ],
      },
      {
        name: ENTRY_POINTS.Square_Control_Unit,
        translatedName: this.translate.instant(
          '+GATEWAY_COMMISSIONING_REDESIGN.SQUARE_CONTROL_UNIT_NAME'
        ),
        instructions: [
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SQUARE_CONTROL_UNIT_1'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SQUARE_CONTROL_UNIT_2'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SQUARE_CONTROL_UNIT_3'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SQUARE_CONTROL_UNIT_4'
          ),
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_SQUARE_CONTROL_UNIT_5'
          ),
        ],
      },
      {
        name: ENTRY_POINTS.Vitoair,
        translatedName: this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.VITOAIR_NAME'),
        instructions: [
          this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VITOAIR'),
        ],
      },
      {
        name: ENTRY_POINTS.Vitovent,
        translatedName: this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.VITOVENT_NAME'),
        instructions: [
          this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VITOVENT'),
        ],
      },
      {
        name: ENTRY_POINTS.Viessmann_Invisible,
        translatedName: this.translate.instant(
          '+GATEWAY_COMMISSIONING_REDESIGN.VIESSMANN_INVISIBLE_NAME'
        ),
        instructions: [
          this.translate.instant(
            '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VIESSMANN_INVISIBLE'
          ),
        ],
      },
      {
        name: ENTRY_POINTS.Vitopure,
        translatedName: this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.VITOPURE_NAME'),
        instructions: [
          this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VITOPURE'),
        ],
      },
      {
        name: ENTRY_POINTS.Vitoset_Aqua,
        translatedName: this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.VITOSET_AQUA_NAME'),
        instructions: [
          this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VITOSET_AQUA_1'),
          this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VITOSET_AQUA_2'),
          this.translate.instant('+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_VITOSET_AQUA_3'),
        ],
      },
    ];
  }

  nextStepClicked(): void {
    this.gatewayCommissioningStore.setActiveStep({
      activeStep: GATEWAY_COMMISSIONING_STEP.PROVIDE_TRANSFER_DATA,
    });
    this.nextStep.emit();
  }

  previousStepClicked(): void {
    this.gatewayCommissioningStore.clearState();
    this.previousStep.emit();
  }
}
